var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import ReportStockService from "../../../api/ReportStockService";
import CommonService from "../../../api/CommonService";
import { billDefaultDate } from "../../../helper/defaultDate";
function tidyDepotList(treeData) {
    treeData.forEach(function (item) {
        if (item.organ_id && !item.depot_id) {
            item.depot_id = "organ_id_" + item.organ_id;
            item.depot_name = item.organ_name;
        }
        if (item.children && item.children.length) {
            tidyDepotList(item.children);
        }
    });
}
var QueryHeader = (function (_super) {
    __extends(QueryHeader, _super);
    function QueryHeader() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.depotList = [];
        _this.categoryData = [];
        _this.instructionsVisible = false;
        _this.startPickerOptions = {
            disabledDate: function (time) {
                var e_time = billDefaultDate().End.format('yyyy-MM-dd');
                if (e_time) {
                    var e_time_time = new Date(e_time).getTime();
                    return time.getTime() > e_time_time;
                }
                else {
                    return false;
                }
            }
        };
        _this.endPickerOptions = {
            disabledDate: function (time) {
                var s_time = billDefaultDate().Start.format('yyyy-MM-dd');
                var s_time_time = new Date(s_time).getTime() - 8.64e7;
                return !(time.getTime() > s_time_time
                    &&
                        time.getTime() <= s_time_time + 365 * 1000 * 24 * 60 * 60);
            }
        };
        return _this;
    }
    QueryHeader.prototype.mounted = function () {
        this.getOrganDepot();
        this.getCategory();
    };
    QueryHeader.prototype.created = function () {
        this.service = ReportStockService.getInstance();
        this.commonService = CommonService.getInstance();
    };
    QueryHeader.prototype.normalizer = function (node) {
        return {
            id: node.goods_type_id,
            label: node.goods_type_name,
            children: node.children,
        };
    };
    QueryHeader.prototype.normalizerDepot = function (id, name) {
        if (id === void 0) { id = "id"; }
        if (name === void 0) { name = "name"; }
        return function (node) { return ({
            id: node[id],
            label: node[name],
            children: node.children,
        }); };
    };
    QueryHeader.prototype.getOrganDepot = function () {
        var _this = this;
        var params = { is_init: 1 };
        this.commonService.getOrganDepot(params).then(function (res) {
            _this.depotList = [];
            if (res.data.data) {
                var depot = res.data.data;
                tidyDepotList(depot);
                _this.depotList = depot;
            }
        }).catch(function (err) {
            _this.$message.error(err.message || err.msg);
        });
    };
    QueryHeader.prototype.getCategory = function () {
        var _this = this;
        this.service.getCategory().then(function (res) {
            if (res.data.success) {
                _this.categoryData = res.data.data;
            }
            else {
                _this.$message.error(res.data.msg);
            }
        }, function (err) {
            _this.$message.error(err.message || err.msg);
        }).catch(function (err) {
            _this.$message.error(err.message);
        });
    };
    QueryHeader.prototype.openInstructions = function ($event) {
        $event.stopPropagation();
        this.instructionsVisible = true;
        window.addEventListener("click", this.closeInstructions);
    };
    QueryHeader.prototype.closeInstructions = function () {
        this.instructionsVisible = false;
        window.removeEventListener("click", this.closeInstructions);
    };
    QueryHeader.prototype.searchClick = function () {
        this.$emit('searchClick');
    };
    QueryHeader.prototype.reset = function () {
        this.$emit('reset');
    };
    QueryHeader.prototype.exportData = function () {
        this.$emit('exportData');
    };
    __decorate([
        Prop({
            type: Object
        })
    ], QueryHeader.prototype, "formData", void 0);
    __decorate([
        Prop({
            type: Array
        })
    ], QueryHeader.prototype, "instructionsData", void 0);
    __decorate([
        Prop({
            type: Boolean,
            default: true
        })
    ], QueryHeader.prototype, "instructionsShow", void 0);
    __decorate([
        Prop({
            type: Object,
            default: function () {
                return {};
            }
        })
    ], QueryHeader.prototype, "pageAuth", void 0);
    QueryHeader = __decorate([
        Component({
            watch: {
                'formData.s_time': function (newVal, oldVal) {
                    this.endPickerOptions = {
                        disabledDate: function (time) {
                            var s_time_time = new Date(newVal).getTime() - 8.64e7;
                            return !(time.getTime() > s_time_time
                                &&
                                    time.getTime() <= s_time_time + 365 * 1000 * 24 * 60 * 60);
                        }
                    };
                },
                'formData.e_time': function (newVal, oldVal) {
                    this.startPickerOptions = {
                        disabledDate: function (time) {
                            if (newVal) {
                                var e_time_time = new Date(newVal).getTime();
                                return time.getTime() > e_time_time;
                            }
                            else {
                                return false;
                            }
                        }
                    };
                }
            }
        })
    ], QueryHeader);
    return QueryHeader;
}(Vue));
export default QueryHeader;
